/** Max entries kept on the vacancy JSON to avoid unbounded growth */
export const MAX_VACANCY_FLOW_STEP_HISTORY = 200;

/** `navigate` is legacy (no longer written); kept for old rows in JSON. */
export type VacancyFlowStepHistoryKind = 'navigate' | 'intake_save' | 'save';

export interface VacancyFlowStepHistoryEntry {
  at: string;
  stepId: string;
  stepLabel: string;
  kind: VacancyFlowStepHistoryKind;
  fromStepId?: string;
  fromStepLabel?: string;
  /** Dutch one-liners, e.g. "Deadline aangepast" */
  changeSummaries?: string[];
  userId?: string;
  userName?: string;
  userEmail?: string;
  userRole?: string;
}

export type VacancyFlowActor = {
  id?: string;
  name?: string;
  email?: string;
  role?: string;
};

/**
 * Appends one workflow step / intake event to `data.flowStepHistory` (immutable).
 */
export function appendVacancyFlowStepHistory(
  data: Record<string, unknown> | undefined,
  entry: Omit<VacancyFlowStepHistoryEntry, 'at' | 'userId' | 'userName' | 'userEmail' | 'userRole'>,
  actor?: VacancyFlowActor
): Record<string, unknown> {
  const summaries = entry.changeSummaries?.filter(Boolean) || [];
  if (entry.kind !== 'navigate' && summaries.length === 0) {
    return { ...(data || {}) };
  }
  const base: Record<string, unknown> = { ...(data || {}) };
  const prev = Array.isArray(base.flowStepHistory)
    ? ([...base.flowStepHistory] as VacancyFlowStepHistoryEntry[])
    : [];
  const row: VacancyFlowStepHistoryEntry = {
    at: new Date().toISOString(),
    ...entry,
    userId: actor?.id,
    userName: actor?.name,
    userEmail: actor?.email,
    userRole: actor?.role,
  };
  prev.push(row);
  base.flowStepHistory = prev.slice(-MAX_VACANCY_FLOW_STEP_HISTORY);
  return base;
}
